import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import ServiceFeatures from "./components/ServiceFeatures";
import CategoryNav from "./components/CategoryNav";
import LatestArticles from "./components/LatestArticles";
import Testimonials from "./components/Testimonials";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <ServiceFeatures />
        <CategoryNav />
        <LatestArticles />
        <Testimonials />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "91.cn 首页",
          "url": "https://www.91.cn",
          "description": "91.cn 官方首页，全面介绍平台核心功能、服务优势与使用指南",
          "isPartOf": {
            "@type": "WebSite",
            "name": "91.cn",
            "url": "https://www.91.cn"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "91.cn 提供哪些核心服务？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "91.cn 提供包括数据存储与管理、智能分析决策、团队协作办公、API 接口对接、安全防护、内容分发等八大核心服务模块，覆盖个人用户和企业用户的多种使用场景。"
              }
            },
            {
              "@type": "Question",
              "name": "如何注册 91.cn 账号？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "注册 91.cn 账号非常简单：点击页面右上角的「注册」按钮，输入您的手机号码或邮箱地址，设置密码并完成验证码验证，即可在 30 秒内完成注册。"
              }
            },
            {
              "@type": "Question",
              "name": "91.cn 的服务收费模式是怎样的？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "91.cn 采用灵活的分层定价策略：基础版免费，专业版每月 29 元起，企业版按需定制。所有套餐均可随时升级或降级。"
              }
            },
            {
              "@type": "Question",
              "name": "企业用户如何接入 91.cn 平台？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "企业用户可通过以下步骤快速接入：注册企业账号并完成企业认证、联系商务团队获取定制方案、通过 API 接口或 SDK 快速集成、专属技术团队全程支持。"
              }
            },
            {
              "@type": "Question",
              "name": "91.cn 的数据安全性如何保障？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "91.cn 采用多层次安全防护体系：数据传输使用 HTTPS/SSL 加密，数据存储采用 AES-256 加密算法，并通过了 ISO 27001 信息安全管理体系认证。"
              }
            }
          ]
        })}
      </script>
    </>
  );
}